<template>
  <div>
    <div class="overlay"></div>
    <div class="video">
      <div class="panel">
        <span class="title">{{ title }}</span>
        <button @click="$emit('close')" type="button" class="close" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <iframe
        scrolling="no"
        marginheight="0"
        marginwidth="0"
        :src="url"
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope"
      ></iframe>
    </div>
  </div>
</template>

<style scoped lang="scss">
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9998;
  background: #000;
}

.video {
  z-index: 9999;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  .panel {
    z-index: 9999;
    background: black;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    height: 50px;
    text-align: left;

    span.title {
      overflow: hidden;
      text-overflow: ellipsis;
      color: white;
      font-size: 1.5em;
      line-height: 2em;
      position: absolute;
      left: 0.5em;
      right: 50px;
      top: 0;
      height: 50px;
      display: inline-block;
      white-space: nowrap;
    }

    button span {
      color: white !important;
      font-size: 2em;
      margin-right: 0.25em;
    }
  }

  iframe {
    position: fixed;
    width: 100%;
    height: 100%;
    padding-top: 50px;
    left: 0;
  }
}
</style>

<script>
export default {
  name: 'EmbedViewer',
  props: {
    url: String,
    title: String
  },
  mounted() {
    document.body.classList.add('modal-open');
  },
  beforeDestroy() {
    document.body.classList.remove('modal-open');
  }
};
</script>
